import React from 'react';
import { SlidePage } from '../index';
import { BodyContainer, ProgressBox, ProgressStat } from '../styles';
import { polarColors } from '../constants';

const getColor = value => {
  if (value < 25) {
    return polarColors[4];
  }
  if (value < 50) {
    return polarColors[3];
  }
  if (value < 75) {
    return polarColors[1];
  }
  return polarColors[0];
};

const getSumFomValues = (values = []) => {
  const sum = values
    .filter(Boolean)
    .reduce((acc, curr) => acc + parseFloat(curr), 0);
  return sum;
};

const getMeanFromValues = (values = []) => {
  const sum = getSumFomValues(values);
  const mean = sum / values.length;
  return mean;
};

const VocationalMaturityFourPage = ({ user, background, number }) => {
  const infoSobreProceso = parseFloat(user['Información sobre el proceso']);
  const infoInconsistenteFallback =
    (getMeanFromValues([user['DI_19'], user['DI_20'], user['DI_21']]) / 9) *
    100;
  const infoInconsistente = user['Información inconsistente']
    ? parseFloat(user['Información inconsistente'])
    : infoInconsistenteFallback;

  // console.log({ infoInconsistente });
  return (
    <SlidePage number={number} background={background}>
      <BodyContainer>
        <div className='content'>
          <h3 style={{ marginBottom: '0.5rem' }}>
            Falta de información sobre el proceso.{' '}
          </h3>
          <p className='justified'>
            La{' '}
            <strong>
              incertidumbre sobre cómo abordar la toma de decisiones
              vocacionales
            </strong>{' '}
            puede ser un obstáculo considerable. Esta falta de claridad no solo
            se refiere a desconocer los pasos a seguir, sino también a no
            comprender las emociones y experiencias que son parte del proceso.{' '}
            <strong>
              Es común preguntarse si lo que se siente es "normal" o si se está
              abordando el proceso de la manera adecuada
            </strong>
            . O quizás te surgen las siguientes preguntas ¿Cómo se hace para
            tomar esta decisión? ¿Qué puedo esperar de este proceso? ¿Es normal
            lo que siento?
          </p>
          <div className='paragraph'>¿Cómo afrontar esta situación?</div>
          <ul className='text-list'>
            <li>- Ayuda profesional (coach vocacional).</li>
            <li>
              - Desarrolla un plan de acción para abordar todas las dudas que
              tienes e identifica qué o quienes podrían ayudarte a responder
              estas dudas.
            </li>
            <li>
              - Mentoría, consulta con alguien que haya realizado este proceso y
              pregúntale qué pasos siguió.
            </li>
          </ul>
          <br />
          <div className='progress-info-group'>
            <div className='progress-info'>
              <div className='progress-details-single'>
                {/* <div className='progress-name'>
                  Falta de información sobre el proceso
                </div> */}
                <ProgressBox
                  progress={infoSobreProceso}
                  backColor={() => getColor(infoSobreProceso)}
                >
                  <div className='progress'></div>
                </ProgressBox>
                <ProgressStat>{infoSobreProceso}</ProgressStat>
              </div>
            </div>
          </div>
          <br />
          {user['DI_21'] && (
            <>
              <h3 style={{ marginBottom: '0.5rem' }}>
                Información Inconsistente.{' '}
              </h3>
              <p className='justified'>
                En ocasiones, nuestras dificultades no se relacionan con falta
                de información, sino que tenemos información que es
                inconsistente, ya sea sobre nosotros mismos o sobre las carreras
                que nos interesan. Puede haber{' '}
                <strong>contradicciones en las cosas que te interesan</strong>{' '}
                (por ejemplo, a veces piensas que quieres ser independiente,
                pero otras veces piensas que es mejor trabajar en una empresa),{' '}
                <strong>
                  o entre la forma en que tu percibes a ti mismo y la forma en
                  que te ven los otros
                </strong>{' '}
                (por ejemplo, hay personas que te dicen que eres muy bueno/a
                para algo, pero tú no lo crees así). También podemos tener
                información contradictoria sobre las carreras que nos interesan
                (por ejemplo, has leído que la carrera que te interesa tiene un
                amplio campo laboral, pero muchas personas te han dicho que hay
                poco trabajo en esa área).
              </p>
              {/* <p className='justified'>
            Ejemplos, te encuentra en tu último año de colegio y sabes que
            tienes que decidir pronto qué carrera estudiar. Sin embargo, no
            tienes idea de cómo comenzar, qué factores considerar, o cómo
            investigar sobre las opciones que tienes en mente.
          </p> */}
              <div className='paragraph'>¿Cómo afrontar esta situación?</div>
              <ul className='text-list'>
                <li>- Ayuda profesional (coach vocacional).</li>
                <li>
                  - Identificar y analizar la información que es inconsistente,
                  e indagar con mayor profundidad para aclarar esas
                  contradicciones.
                </li>
              </ul>
              <br />
              <div className='progress-info-group'>
                <div className='progress-info'>
                  <div className='progress-details-single'>
                    {/* <div className='progress-name'>
                  Falta de información sobre el proceso
                </div> */}
                    <ProgressBox
                      progress={infoInconsistente}
                      backColor={() => getColor(infoInconsistente)}
                    >
                      <div className='progress'></div>
                    </ProgressBox>
                    <ProgressStat>{infoInconsistente.toFixed()}</ProgressStat>
                  </div>
                </div>
              </div>
            </>
          )}

          <br />
        </div>
      </BodyContainer>
    </SlidePage>
  );
};

export default VocationalMaturityFourPage;
